import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';

@Component({
    selector: 'app-order-maintainence',
    templateUrl: './order-maintainence.component.html',
    styleUrls: ['./order-maintainence.component.scss'],
    standalone: false
})
export class OrderMaintainenceComponent implements OnInit {
  user: UsersDataResponse;
  userData: UserData;
  navLinks: any[];
  activeLinkIndex = -1;
  activeLink: any;
  background = '';
  userAction= '';
 
  orderList = [

    {
      label: 'Order Details',
      path: './order-details',
      index: 0
    },
    {
      label: 'Order Confirmation',
      path: './order-confirmation',
      index: 1
    },
    {
      label: 'Receipt Confirmation',
      path: './receipt-confirmation',
      index: 2
    },
      
  ];
  
  

  constructor(private route: ActivatedRoute,
    private router: Router, private userservice: UserService) {
    
    this.userservice.getCurrentUser().subscribe(data => {
      this.user = data;
      this.userData = data.userData;
      this.navLinks=this.orderList;

  //     this.route.queryParams
  //     .subscribe(params => {
  //      this.router.navigate(['/order-details'], params['dc-store-number'])
     
      
     

  // })
})


  }
  ngOnInit(): void {
 //   if(this.routeEnable===true){
    this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.path === '.' + this.router.url));
    });
  //}


  }

}
